import { z } from "zod";

/**
 * An ISO-8601 datetime string on the wire.
 *
 * tRPC has no Date transformer in this app, so every date crosses the wire as
 * a string. Using bare `z.string()` for those fields lets any junk through the
 * output validators; this type actually checks the shape. `offset`/`local`
 * accept `Z`, `±hh:mm`, or no timezone — every producer here uses
 * `Date.prototype.toISOString()` (always `Z`), the looser options just keep
 * the validator from being the thing that breaks if a producer ever differs.
 *
 * Compose as usual: `IsoDateString.nullable()`, `IsoDateString.nullish()`.
 */
export const IsoDateString = z.iso.datetime({ offset: true, local: true });
export type IsoDateString = z.infer<typeof IsoDateString>;
